import snakeCaseKeys from 'snakecase-keys';
import { forwardStoryEvents } from './analytics/story';
import { forwardVariantEvents } from './analytics/variant';

const URL_VISITS = '/ahoy/events';

/**
 * Sets up player analytics
 * @param {Object} options
 * @param {String} [options.viewingId] - An viewing ID to attach the events to
 * @param {String} [options.projectId] - The ID of the project being viewed
 */
export default function setupAnalytics({ viewingId, projectId }) {
  const visitToken = viewingId || generateId();
  if (!isDoNotTrackEnabled()) {
    // Because the `story_shown` also sets a couple
    // of metadata alongside the event's properties
    // it needs to be sent on its own rather than forwarded
    // from the player events. Especially as timings don't
    // really matter here
    sendEvent({
      name: 'story_shown',
      // Some extra metadata for Ahoy
      platform: 'Web',
      js: true,
      referrer: document.referrer || null,
      landing_page: window.location.href
    });

    // STORY EVENTS
    forwardStoryEvents(sendEvent);
    forwardVariantEvents(sendEvent);
  }

  // The throttled method will take care of sending the last

  function sendEvent({ name, properties, ...metadata }) {
    // Create a visit ourselves as ahoy relies on cookies
    // to manage visitIds
    $.ajax(URL_VISITS, {
      method: 'POST',
      // Send JSON rather than `application/x-www-form-urlencoded` data
      // to preserve types. We need to do the stringify ourselves though :'(
      contentType: 'application/json',
      data: JSON.stringify({
        visit_token: visitToken,
        visitor_token: null, // We're not tracking visitors
        name,
        // https://github.com/ankane/ahoy/blob/2515f80d50657014c1531dac05e1f5b4045cb47e/app/controllers/ahoy/events_controller.rb#L26
        // Ahoy will parse ISOStrings
        time: new Date().toISOString(),
        properties: {
          project_id: projectId,
          ...snakeCaseKeys(properties || {})
        },
        ...metadata
      })
    });
  }
}

// Same ID generator as Ahoy.js
// https://stackoverflow.com/a/2117523/1177228
function generateId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

//https://medium.com/farewill/how-to-detect-and-use-do-not-track-on-your-website-77f21f62be48
function isDoNotTrackEnabled() {
  const doNotTrackOption =
    window.doNotTrack ||
    window.navigator.doNotTrack ||
    window.navigator.msDoNotTrack;

  if (!doNotTrackOption) {
    return false;
  }

  if (doNotTrackOption.charAt(0) === '1' || doNotTrackOption === 'yes') {
    return true;
  }

  return false;
}
